module.exports = __webpack_public_path__ + "img/384.49793e82.jpg";